import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

import styles from './article-preview.module.scss'

export default ({ article }) => (
  <Link to={`/blog/${article.slug}`} style={{ textDecoration: 'none' }}>
    <div className={styles.preview}>
      <div className="image-wrap divider-up divider-up--landscape">
        <Img
          alt=""
          fluid={article.heroImage.fluid}
          className={styles.image}
          style={{ height: '100%' }}
        />
      </div>
      <div className={styles.textWrap}>
        <h3 className={`${styles.previewTitle} heading h3`}>{article.title}</h3>
        <small>{article.publishDate}</small>
        <div
          className={styles.blurb}
          dangerouslySetInnerHTML={{
            __html: article.description.childMarkdownRemark.html,
          }}
        />
      </div>
    </div>
  </Link>
)
